/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MagiRefineCallbackRequest = {
  id: string;
  status: MagiRefineCallbackRequest.status;
};

export namespace MagiRefineCallbackRequest {
  export enum status {
    COMPLETED = 'completed',
    FAILED = 'failed',
    WAITING = 'waiting',
    ACTIVE = 'active',
    DELAYED = 'delayed',
  }
}
